<template>
    <div class="content-box">
      <div class="element-wrapper">
        <div class="element-box">
          <h5 class="form-header">Listado de Terminales</h5>
          <!-------------------- START - Controles arriba de tabla-------------------->
          <div class="controls-above-table">
            <div class="row">
              <div class="col-sm-6">
                <router-link class="btn btn-sm btn-success" :to="{ name: 'cat-terminal-pos-nuevo', params: {} }">
                  <i class="fa fa-plus"></i>
                  Nueva Terminal POS
                </router-link>
              </div>
              <div class="col-sm-6">
                <form action="#" class="form-inline justify-content-sm-end">
                  <input 
                    class="form-control form-control-sm rounded bright" 
                    placeholder="Buscar..."
                    @keydown.enter="searchData()"
                    v-model="searchText"
                    type="text" 
                  />
                  <select 
                    class="form-control form-control-sm rounded bright"
                    @change="searchData()"
                    v-model="filterEstado"
                  >
                    <option value>Todos</option>
                    <option value="A">Disponible</option>
                    <option value="B">En Uso</option>
                    <option value="9">Inactivo</option>
                  </select>
                  <div class="input-group-append">
                    <button 
                      class="btn btn-link btn-sm" 
                      type="button"
                      @click="searchData()"
                    >
                      <i class="fa fa-search"></i>
                    </button>
                    <button 
                      class="btn btn-link btn-sm" 
                      type="button"
                      @click="clearSearch()"
                    >
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
  
          <!-------------------- END - Controles arriba de tabla-------------------->
          <div class="table-responsive mb-2">
            <!-------------------- Tabla de REsultados -------------------->
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>Terminal ID</th>
                  <th>Fecha de creación</th>
                  <th>Proveedor</th>
                  <th>Número afiliación</th>
                  <th>Tienda</th>
                  <th>Tipo POS</th>
                  <th>Tipo Cobro</th>
                  <th class="text-center">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="terminal in terminales.results" @click="rowClick(terminal)">
                  <td>{{ terminal.terminal_id }}</td>
                  <td>{{ terminal.fecha_creacion }}</td>
                  <td>{{ terminal.afiliacion_tienda_obj.proveedor.nombre }}</td>
                  <td>{{ terminal.afiliacion_tienda_obj.numero }}</td>
                  <td>{{ terminal.afiliacion_tienda_obj.tienda.codigo }}-{{ terminal.afiliacion_tienda_obj.tienda.nombre }}</td>
                  <td>{{terminal.tipo_pos_obj.descripcion }}</td>
                  <td>{{terminal.tipos_cobro_obj.descripcion }}</td>
                  <td class="text-center">
                    <div 
                      :class="{
                        'status-pill green':terminal.estado === 'A',
                        'status-pill blue': terminal.estado === 'B',
                        'status-pill red': terminal.estado === '9',
                      }"
                    ></div>
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
          </div>
          <PaginationComponent :currentPage="currentPage" :data="terminales" @pagechanged="onPageChange" />
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import PaginationComponent from "@/components/utils/PaginationComponent";
  import TerminalPOSService from "@/services/catalogos/TerminalPOSService";
  import Notifications from "@/notifications/notifications";
  import DynamicService from "@/services/commons/DynamicService";
  
  export default {
    components: {
      PaginationComponent,
    },
    data() {
      return {
        terminales: [],
        currentPage: 1,
        filterEstado: "",
        searchText: "",
      };
    },
    mounted() {
      this.refreshData({
          page:1,
        });
    },
    methods: {
      refreshData(params){
        TerminalPOSService.fetch(params).then(response => {
          this.terminales = response.data;
        })
      },
      rowClick(row) {
        let self = this;
        if (event.ctrlKey) {
          let routeUrl = this.$router.resolve({
            name: "cat-terminal-pos-editar",
            params: { id: row.id },
          });
          window.open(routeUrl.href, "_blank");
        } else {
          self.$router.push({
            name: "cat-terminal-pos-editar",
            params: { id: row.id },
          });
        }
      },
      onPageChange(page) {
        this.currentPage = page;
        this.refreshData({
          page: this.currentPage,
          "filter[search]": this.searchText,
          estado: this.filterEstado,
        });
      },
      clearSearch(){
        this.searchText = "";
        this.filterEstado = "";
        this.refreshData({
          page: 1,
          "filter[search]": this.searchText,
          estado: this.filterEstado,
        });
      },
      searchData(){
        this.refreshData({
          page: 1,
          "filter[search]": this.searchText,
          estado: this.filterEstado,
        });
      },
    },
  };
  </script>
  